import type { SVGProps } from 'react';
const SvgIconMenuClose = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M3.404 2.343a.75.75 0 0 0-1.06 1.06L6.938 8l-4.596 4.596a.75.75 0 0 0 1.06 1.06L8 9.062l4.596 4.596a.75.75 0 0 0 1.06-1.06L9.062 8l4.596-4.596a.75.75 0 1 0-1.06-1.06L8 6.938z"
    />
  </svg>
);
export default SvgIconMenuClose;
